/**
 * Created by charnjeetelectrovese@gmail.com on 9/13/2017.
 */
// import { getRecaptchaToken } from '../libs/recaptcha.utils';
import { getTurnstileToken } from '../libs/turnstile.utils';
import axios from 'axios';
import Constants from '../config/constants';
import {getRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceLoginUser(data) {
    // const [recaptcha_token, turnstile_token] = await Promise.all([
    //     getRecaptchaToken('LOGIN'),
    //     getTurnstileToken('login'),
    // ]);
    // return await postRequest('login', { ...data, recaptcha_token, turnstile_token });
    // const recaptcha_token = await getRecaptchaToken('LOGIN');
    // return await postRequest('login', { ...data, recaptcha_token });
    const turnstile_token = await getTurnstileToken('login');
    return await postRequest('login', { ...data, turnstile_token });
}

export async function serviceLogoutUser(data) {
    return await postRequest('logout', data);
}
export async function serviceGetProfile () {
    return await postRequest('profile', {});
}

export async function serviceGetListData() {
    return await getRequest('list/data', {});
}
export async function serviceForgotPassword(params) {
    return await postRequest('forgot/password', params);
}

export async function serviceResetPassword(params) {
    return await postRequest('reset/password', params);
}

export async function serviceChangePassword(params) {
    return await postRequest('change/password', params);
}

export async function serviceLoginSupport(params) {
    return await postRequest('login/support', params);
}

export async function servicePasswordVerify(params) {
    return await postRequest('password/verify', params);
}
